import { createSlice } from '@reduxjs/toolkit';
import { DEFAULT_PAGE, DEFAULT_PER_PAGE } from '../../constants/pagination';

const initialState = {
  currentPage: DEFAULT_PAGE,
  perPageNumber: DEFAULT_PER_PAGE,
  filterParams: {},
  searchQuery: '',
};

export const nayaxSlice = createSlice({
  name: 'nayax',
  initialState,
  reducers: {
    setNayaxPagination: (state, action) => {
      state.currentPage = Math.max(1, action.payload.currentPage);
      state.perPageNumber = action.payload.perPageNumber;
    },
    setNayaxFilters: (state, action) => {
      state.filterParams = action.payload.filterParams || {};
      state.searchQuery = action.payload.searchQuery || '';
      state.currentPage = DEFAULT_PAGE;
    },
    resetNayaxState: (state) => {
      Object.assign(state, initialState);
    },
  },
});

export const { setNayaxPagination, setNayaxFilters, resetNayaxState } = nayaxSlice.actions;

export default nayaxSlice.reducer;
